module.exports = __webpack_public_path__ + "static/img/info_icon.acbcc70e.png";